import { defineMessages } from 'react-intl';

export default defineMessages({
  newName: 'New Board Name',
  success: 'Board renamed',
  title: 'Rename Board'
});
